import { mockSuccess, listPayload } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

const DOMAIN_ROWS = [
    { id: 'dom-1', hostname: 'ashcorp.xyz', site_id: 'mock-1', ssl_status: 'active', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'dom-2', hostname: 'outbox.ashcorp.xyz', site_id: 'mock-2', ssl_status: 'active', updated_at: '2026-06-04T12:00:00Z' },
];

const ROWS = [
    { id: 'mock-1', title: 'ashcorp.xyz', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-2', title: 'client-portal.dev', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-3', title: 'campaign-landing', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
];

export const WEBSITE_MOCK_HANDLERS: MockRouteEntry[] = [
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/website\/domains(\?|$)/i,
        handler: () => mockSuccess(listPayload(DOMAIN_ROWS)),
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/website\/domains\/([^/?]+)/i,
        handler: (req) => {
            const match = req.url.match(/\/domains\/([^/?]+)/i);
            const id = match ? match[1] : '';
            const row = DOMAIN_ROWS.find((r) => r.id === id) ?? DOMAIN_ROWS[0];
            return mockSuccess(row);
        },
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/website\/sites(\?|$)/i,
        handler: () => mockSuccess(listPayload(ROWS)),
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/website\/sites\/([^/?]+)/i,
        handler: (req) => {
            const match = req.url.match(/\/sites\/([^/?]+)/i);
            const id = match ? match[1] : '';
            const row = ROWS.find((r) => r.id === id) ?? ROWS[0];
            return mockSuccess(row);
        },
    },
];
